import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            No online strategy is complete without Google Ads
          </h3>
          <p>
            No online strategy is complete without Adwords. We're your
            profit-focussed Google Ads experts. We've helped small and large
            companies with budgets exceeding $3,000,000 tunr their wasteful ad
            spend into sustained profitability. Let us help you do the same.
            <br />
            <h3 className={classes.title}>
              Overview of our Google Ads service
            </h3>
            Australians spent <strong>992 million hours</strong> Googling on
            average. Don’t miss out on tapping into this huge market of
            ready-to-buy prospects. Google Ads is the most{" "}
            <strong>profitable, popular and fastest</strong> way to generate
            leads. It’s also complex and time-consuming. That’s why we’ve
            assembled a <strong>team of experts</strong> to manage your complex
            Google Ads campaigns. We specialise in helping you make sense of
            your marketing data, so you can generate revenue within your
            specific marketing budget. <br />
          </p>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <h3 className={classes.title}>
            Actual examples of our analytical approach & expertise
          </h3>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-ads-services/shopping-ads.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Shopping Ads
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-ads-services/google-ads-dashboard.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Reports in Data Studio
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/google-ads-services/sheets-reporting-google-ads.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Detailed Tracking in Google Sheets
                </i>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            What's included in our Google Ads package?
          </h3>
          You will receive a complete Google Ads campaign setup, which includes:
          <ul>
            <li>Competitor Analysis</li>
            <li>Conversion Optimisation</li>
            <li>Complete Management Of Your Account</li>
            <li>Keyword Research & Optimization</li>
            <li>Outstanding Ad Copy</li>
            <li>Enhance Ads With Ad Extensions</li>
            <li>Device Optimization</li>
            <li>Bid Management</li>
            <li>
              Negative Keyword Implementation To Exclude Irrelevant Traffic
            </li>
            <li>
              Reporting In a Professional PDF and Your Own Personal Dashboard
              (see here for demo)
            </li>
          </ul>
          <Quote
            textClassName={classes.quoteText}
            text="“The work completed for Prezzee has not only improved the analytics and tagging functions, but also had a positive impact of user experience as well as improvements to Prezzee’s back end processes.”"
            author="Renee Gangemi, Director at The Marketing Equation / Prezzee"
          />
          <h3 className={classes.title}>Our guarantee to you:</h3>
          <ul>
            <li>No Lock in Contracts </li>
            <li>We treat your campaigns as if they were my own </li>
            <li>
              Full transparency over the costs, you have admin access to the
              account
            </li>
            <li>100% Customer Satisfaction, Real Results</li>
            <li>
              All keywords are carefully selected. We don't want you to have
              unwanted traffic that you pay for
            </li>
          </ul>
          <h3 className={classes.title}>Why Us?</h3>
          <p>
            ✅ We optimise for conversions, not just clicks <br />
            ✅ Quality Over Quantity - We only work with a limited number of
            clients at a time, we're not an agency that tries to get as many
            clients as possible.
            <br />
            ✅ Speedy Response Time
            <br />
            ✅ 9+ Years of Experience in PPC / Adwords
            <br />
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our Approach</h3>

          <p>
            We see digital marketing as a great relationship, from the very
            first chat to a happily ever after. Here's how it works:
            <br />
          </p>
          <ol>
            <li>
              <strong>Fill in the form at the bottom of this page</strong>:
              During the call, we get to know each other, to understand your
              goals and for you to understand how we can help you.{" "}
              <i>(We get to know each other on our first date!)</i>
            </li>
            <li>
              {" "}
              <strong>We get down to creating a marketing plan for you</strong>:
              The plan will be specifically tailored to your business needs and
              goals
              <i>
                (This is where the magic happens! Sparks flies, butterflies in
                stomach, think of the possibilities!)
              </i>
            </li>
            <li>
              {" "}
              <strong>We execute your marketing plan:</strong> This is where you
              watch your revenue grow.{" "}
              <i>
                (Like any good date, we hit the ground running and it’s like
                nothing you’ve ever experienced before)
              </i>
            </li>
            <li>
              {" "}
              <strong>Grow, Win, Celebrate! </strong>{" "}
              <i>(Wedding! Okay maybe that’s too soon…)</i>
            </li>
          </ol>
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
